import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import { useLanguage } from "../context/LanguageContext";
import { supportedLanguages } from '../utils/SupportedLanguages';

const Header = ({ onProfileClick, showProfileIcon, onLanguageClick, languageLabel }) => {
  const { currentLanguage, changeLanguage, t } = useLanguage();
  const langMeta = supportedLanguages.find(lang => lang.code === currentLanguage);
  const isRtl = langMeta?.direction === 'rtl';
  console.log("Lang Direction: ", langMeta?.direction);
  return (
    <AppBar
      position="static"
      color="white"
      elevation={0}
      sx={{
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.06)',
        borderBottom: '1px solid #e0e0e0',
        direction: isRtl ? 'rtl' : 'ltr'
      }}
    >
      <Toolbar>
        {/* Logo */}
        <Box sx={{
          display: "flex",
          alignItems: "center",
          pl: isRtl ? 0 : 2,
          pr: isRtl ? 2 : 0,
          py: 1
        }}>
          <img
            src="/Refugee-Resources-Logo-20241114.png"
            alt="Refugee Resources"
            style={{ width: "160px", height: "auto" }}
          />
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        {/* Language Selector - Now using IconButton with PublicOutlinedIcon */}
        <IconButton
          onClick={onLanguageClick}
          sx={{
            color: '#E27A58',
            mr: 2,
            '&:hover': {
              backgroundColor: 'rgba(226, 122, 88, 0.08)'
            }
          }}
          aria-label="Change language"
        >
          <PublicOutlinedIcon fontSize="large" />
        </IconButton>

        {/* Profile Icon */}
        {showProfileIcon && (
          <IconButton onClick={onProfileClick} aria-label="Profile">
            <AccountCircleIcon fontSize="large" sx={{ color: "#E27A58" }} />
          </IconButton>
        )}
        <Box sx={{
          display: 'flex',
          flexDirection: isRtl ? 'row-reverse' : 'row'
        }}>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
